import React, { useState, useEffect } from 'react';
import { fetchTechServices } from '../services/techServicesService';
import { fetchDistrictsByCity, fetchCities } from '../services/locationsService';

const TechServiceSelectStep = ({
  selectedTechService,
  setSelectedTechService,
  autoSelectedTechService,
  serviceRecordId
}) => {
  const [showManualSelection, setShowManualSelection] = useState(false);
  const [iller, setIller] = useState([]);
  const [ilceler, setIlceler] = useState([]);
  const [techServiceCityId, setTechServiceCityId] = useState('');
  const [techServiceDistrictId, setTechServiceDistrictId] = useState('');
  const [techServices, setTechServices] = useState([]);
  const [loading, setLoading] = useState(false);

  // Load cities
  useEffect(() => {
    const loadCities = async () => {
      try {
        const response = await fetchCities();
        const list = response?.veri?.iller || response?.veri || [];
        setIller(Array.isArray(list) ? list : []);
      } catch (err) {
        console.error('İller yüklenemedi:', err);
      }
    };
    loadCities();
  }, []);

  // Load districts when city selected
  useEffect(() => {
    const loadDistricts = async () => {
      if (!techServiceCityId) {
        setIlceler([]);
        return;
      }

      try {
        const cityIdNum = parseInt(techServiceCityId, 10);
        const response = await fetchDistrictsByCity(cityIdNum);
        let list = response?.veri?.ilceler || response?.veri || [];
        
        const serializedList = list.map((ilce) => ({
          id: ilce._doc?.id || ilce.id,
          adi: ilce._doc?.adi || ilce.adi || ilce.ad || ilce.name,
          cityId: ilce._doc?.cityId || ilce.cityId
        }));
        
        setIlceler(serializedList);
      } catch (err) {
        console.error('İlçeler yüklenemedi:', err);
        setIlceler([]);
      }
    };

    loadDistricts();
  }, [techServiceCityId]);

  // Load tech services when city/district selected
  useEffect(() => {
    const loadTechServices = async () => {
      if (!techServiceCityId) {
        setTechServices([]);
        return;
      }

      setLoading(true);
      try {
        const params = {
          cityId: parseInt(techServiceCityId, 10),
          aktif: true
        };

        if (techServiceDistrictId) {
          params.districtId = parseInt(techServiceDistrictId, 10);
        }

        const response = await fetchTechServices(params);
        const list = response?.veri?.teknikServisler || response?.veri || [];
        setTechServices(Array.isArray(list) ? list : []);
      } catch (err) {
        console.error('Teknik servisler yüklenemedi:', err);
        setTechServices([]);
      } finally {
        setLoading(false);
      }
    };

    loadTechServices();
  }, [techServiceCityId, techServiceDistrictId]);

  const handleSelectTechService = (service) => {
    setSelectedTechService(service);
    setShowManualSelection(false);
  };

  if (autoSelectedTechService && !showManualSelection) {
    return (
      <div className="tech-service-select-step">
        <div className="step-title-modern">
          <div className="step-title-icon">
            <i className="fas fa-building"></i>
          </div>
          <div className="step-title-content">
            <h3>Teknik Servis Seçimi</h3>
            <p>Randevu için teknik servisi seçiniz</p>
          </div>
        </div>

        <div style={{ marginTop: '20px' }}>
          {/* Otomatik Seçili Badge */}
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '6px 14px',
            background: '#ecfdf5',
            border: '1px solid #6ee7b7',
            borderRadius: '6px',
            marginBottom: '16px'
          }}>
            <i className="fas fa-check-circle" style={{ color: '#10b981', fontSize: '14px' }}></i>
            <span style={{ color: '#059669', fontSize: '13px', fontWeight: 600 }}>
              Otomatik Seçildi
            </span>
          </div>

          {/* Teknik Servis Kartı */}
          <div style={{
            background: 'white',
            border: '2px solid #e5e7eb',
            borderRadius: '8px',
            padding: '16px',
            marginBottom: '16px'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '12px'
            }}>
              <div style={{
                width: '40px',
                height: '40px',
                borderRadius: '8px',
                background: '#f3f4f6',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}>
                <i className="fas fa-building" style={{ fontSize: '18px', color: '#6b7280' }}></i>
              </div>

              <div style={{ flex: 1 }}>
                <h4 style={{
                  margin: '0 0 6px 0',
                  fontSize: '16px',
                  fontWeight: 600,
                  color: '#111827'
                }}>
                  {autoSelectedTechService.ad || autoSelectedTechService.name}
                </h4>
                
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  color: '#6b7280',
                  fontSize: '14px'
                }}>
                  <i className="fas fa-map-marker-alt" style={{ fontSize: '12px' }}></i>
                  <span>
                    {autoSelectedTechService.il?.name || autoSelectedTechService.il?.ad || ''} / {autoSelectedTechService.ilce?.name || autoSelectedTechService.ilce?.ad || ''}
                  </span>
                </div>

                {autoSelectedTechService.adres && (
                  <p style={{
                    margin: '8px 0 0 0',
                    fontSize: '13px',
                    color: '#9ca3af',
                    lineHeight: '1.4'
                  }}>
                    {autoSelectedTechService.adres}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Değiştir Butonu */}
          <button
            type="button"
            className="secondary-btn"
            onClick={() => setShowManualSelection(true)}
            style={{
              width: '100%',
              justifyContent: 'center'
            }}
          >
            <i className="fas fa-edit"></i>
            <span>Farklı Teknik Servis Seç</span>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="tech-service-select-step">
      <div className="step-title-modern">
        <div className="step-title-icon">
          <i className="fas fa-building"></i>
        </div>
        <div className="step-title-content">
          <h3>Teknik Servis Seçimi</h3>
          <p>Randevu için teknik servisi seçiniz</p>
        </div>
      </div>

      <div className="location-filters">
        <div className="form-grid" style={{ gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
          <label className="form-field">
            <span>İl *</span>
            <select
              value={techServiceCityId}
              onChange={(e) => {
                setTechServiceCityId(e.target.value);
                setTechServiceDistrictId('');
                setTechServices([]);
              }}
              required
            >
              <option value="">İl Seçiniz</option>
              {iller.map((il) => (
                <option key={il.id} value={String(il.id)}>
                  {il.name || il.ad}
                </option>
              ))}
            </select>
          </label>

          <label className="form-field">
            <span>İlçe</span>
            <select
              value={techServiceDistrictId}
              onChange={(e) => setTechServiceDistrictId(e.target.value)}
              disabled={!techServiceCityId}
            >
              <option value="">İlçe Seçiniz (Opsiyonel)</option>
              {ilceler.map((ilce) => (
                <option key={ilce.id} value={String(ilce.id)}>
                  {ilce.adi}
                </option>
              ))}
            </select>
          </label>
        </div>
      </div>

      {loading ? (
        <div className="loading-state" style={{ padding: '40px', textAlign: 'center' }}>
          <div className="loading-spinner"></div>
          <p>Teknik servisler yükleniyor...</p>
        </div>
      ) : techServices.length > 0 ? (
        <div className="tech-services-list" style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          marginTop: '20px'
        }}>
          {techServices.map((service) => {
            const serviceId = service.id || service._id;
            const isSelected = selectedTechService && 
              (selectedTechService.id === serviceId || selectedTechService._id === serviceId);
            
            return (
              <div
                key={serviceId}
                onClick={() => handleSelectTechService(service)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px',
                  padding: '16px 20px',
                  background: isSelected ? '#eff6ff' : 'white',
                  border: `2px solid ${isSelected ? 'var(--primary-blue)' : '#e2e8f0'}`,
                  borderRadius: '12px',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  boxShadow: isSelected ? '0 4px 12px rgba(37, 99, 235, 0.15)' : '0 1px 3px rgba(0, 0, 0, 0.05)',
                  position: 'relative',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.borderColor = '#93c5fd';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(37, 99, 235, 0.1)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.borderColor = '#e2e8f0';
                    e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.05)';
                  }
                }}
              >
                {/* Selection indicator */}
                {isSelected && (
                  <div style={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: '4px',
                    background: 'var(--primary-blue)'
                  }}></div>
                )}

                {/* Icon */}
                <div style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '12px',
                  background: isSelected ? 'var(--primary-blue)' : '#f1f5f9',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  transition: 'all 0.2s'
                }}>
                  <i 
                    className={isSelected ? 'fas fa-check-circle' : 'fas fa-building'}
                    style={{
                      fontSize: '24px',
                      color: isSelected ? 'white' : '#64748b'
                    }}
                  ></i>
                </div>

                {/* Content */}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <h4 style={{
                    margin: '0 0 4px 0',
                    fontSize: '16px',
                    fontWeight: 600,
                    color: isSelected ? 'var(--primary-blue)' : 'var(--text-dark)',
                    transition: 'color 0.2s'
                  }}>
                    {service.ad || service.name}
                  </h4>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    fontSize: '14px',
                    color: '#64748b',
                    marginBottom: '4px'
                  }}>
                    <i className="fas fa-map-marker-alt" style={{ fontSize: '12px' }}></i>
                    <span>
                      {service.il?.name || service.il?.ad || ''} / {service.ilce?.name || service.ilce?.ad || ''}
                    </span>
                  </div>
                  {service.adres && (
                    <div style={{
                      fontSize: '13px',
                      color: '#94a3b8',
                      marginTop: '4px',
                      display: '-webkit-box',
                      WebkitLineClamp: 1,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}>
                      {service.adres}
                    </div>
                  )}
                </div>

                {/* Selection badge */}
                {isSelected && (
                  <div style={{
                    padding: '4px 12px',
                    background: 'var(--primary-blue)',
                    color: 'white',
                    borderRadius: '20px',
                    fontSize: '12px',
                    fontWeight: 500,
                    flexShrink: 0
                  }}>
                    Seçildi
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ) : techServiceCityId ? (
        <div className="empty-state" style={{ padding: '40px', textAlign: 'center' }}>
          <i className="fas fa-building" style={{ fontSize: '48px', color: '#cbd5e1', marginBottom: '16px' }}></i>
          <p>Seçilen konumda teknik servis bulunamadı</p>
        </div>
      ) : (
        <div className="info-message" style={{ padding: '20px', background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '8px', color: '#1e40af' }}>
          <i className="fas fa-info-circle"></i>
          <span>Teknik servisleri listelemek için önce il seçiniz</span>
        </div>
      )}
    </div>
  );
};

export default TechServiceSelectStep;
